var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"pa-30 lign-center justify-center"},[_c('v-container',{staticClass:"ma-30 display-3"},[_vm._v("Not Authorized :(")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }